<template>
  <div class="component-root">
    <!-- 业务推荐 -->
    <div class="message-header">
      <em class="icon-dot"></em>相关业务推荐
    </div>
    <ul class="business">
      <li
        v-for="(item, index) in message.content"
        :key="index"
        class="iconClass"
        :style="{ backgroundImage: 'url('+ item.icon +')' }"
        @click="selectItem(item)"
      >
        <a
          :href="item.url"
          target="_blank"
        ></a>
      </li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'RelBusiness',
  props: {
    message: Object
  },
  computed: {
  },
  methods: {
    selectItem (item) {
      console.log('relBusiness-selected-item')
      // 提问
      this.$store.dispatch('askQuestion', {
        from: 2,
        question: item.name,
        dataType: 'relBusiness-selected',
        onlyRobot: true
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.iconClass
  flex-grow: 0 !important
</style>
